<template>
  <div class="container">
    <div class="row">
      <div class="col-12 position-relative">
        <chat-container />
        <div class="chatbot-breadcrumbs">
          <a :href="this.$urls.homeUrl" class="breadcrumb">Homepage</a><span class="separator">/</span><a :href="this.$urls.botUrl" class="breadcrumb">Maison Margiela AI</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatContainer from './components/chat/chat-container.vue';

export default {
    data() {
      return {
      }
    },
    components: {
      ChatContainer
    }
}
</script>
